export default __webpack_public_path__ + "static/media/winners.88dcb56e.svg";